<div class="logo d-flex w-100" data-cy="DIV-c6ee">
  <div class="my-auto mx-4 w-100" data-cy="DIV-b54a">
    <img src="assets/images/logo-vt-by-cc-full-white.svg" alt="visiotalent" class="w-100" />
  </div>
</div>
<div class="content flex-grow-1 w-100 left-shadow" data-cy="DIV-ecc0">
  <ng-content></ng-content>
</div>
